export default __webpack_public_path__ + "static/media/logo-revision.338539b3.png";